import queryString from 'query-string'
import {isArray, isEmpty, isNil, isObject, isString, omitBy, reduce, takeRight} from 'lodash'
import match from 'path-match'

const route = match({
  // path-to-regexp options
  sensitive: false,
  strict: false,
  end: false
})

export const qs = (query, options = {}) => {
  let {
    includeQuestionMark = true
  } = options
  if (isObject(query) && !isEmpty(query)) {
    query = omitBy(query, isNil)
    const queryParams = queryString.stringify(query, {arrayFormat: 'comma'})
    if (queryParams === '') {
      return ''
    }
    return `${includeQuestionMark ? '?' : ''}${queryParams === '?' ? '' : queryParams}`
  }
  if (isString(query)) {
    if (!isEmpty(query)) {
      return queryString.parse(query, {arrayFormat: 'comma'})
    }
    return {}
  }
  return ''
}

export const goBack = (history, navigate, options) => {
  if (history && history.lastUrl) {
    return history.back()
  }
  if (options) {
    if (typeof options === 'string') {
      return navigate(options)
    }
    if (typeof options === 'object') {
      const {
        defaultTo = '',
        returnPath = ''
      } = options
      if (returnPath) {
        const parts = returnPath.split('?')
        let query = {}
        if (parts.length === 2) {
          query = qs(parts[1])
        }
        return navigate(returnPath, {query})
      }
      if (defaultTo) {
        return navigate(defaultTo)
      }
    }
  }
}


export const pathParams = (pathTemplate, actualPath) => {
  pathTemplate = !isArray(pathTemplate) ? [pathTemplate] : pathTemplate
  return pathTemplate.reduce((output, template) => {
    template = template.replace('/*', '')
    template = template.startsWith('/') ? template : `/${template}`
    let actualPathParts = actualPath.split('/').filter(p => p !== '')
    while (actualPathParts.length > 0) {
      const actualPathFragmentIndex = actualPath.indexOf(actualPathParts.join('/'))
      const actualPathFragment = `/${actualPath.substring(actualPathFragmentIndex)}`
      const match = route(template)
      const params = match(actualPathFragment)
      if (params) {
        output = reduce(params, (output, val, key) => {
          // if (output[key] === undefined) {
          output[key] = val
          // }
          return output
        }, output)
      }
      actualPathParts = takeRight(actualPathParts, actualPathParts.length - 1)
    }
    return output
  }, {})
}

export const goTo = (href) => {
  window.location.href = href
}
